import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { REQUIRED_VALIDATION } from 'constants/validation-rules.constants';
import { NotificationInput } from 'interfaces/notifications.interfaces';
import { Card } from 'shared-components/Card';
import { Input } from 'shared-components/Input';
import { Textarea } from 'shared-components/Textarea';

export const NotificationGeneralFields = () => {
  const { formatMessage } = useIntl();

  const {
    register,
    formState: { errors },
  } = useFormContext<NotificationInput>();

  return (
    <Card title='general_info' wrapperClassName='flex-1' className='flex flex-col gap-6'>
      <Input
        {...register('name', REQUIRED_VALIDATION)}
        isRequired
        error={errors['name']?.message as string}
        label='name'
        placeholder={formatMessage({ id: 'name' })}
        data-test='notification-name'
      />
      <Textarea
        {...register('description', REQUIRED_VALIDATION)}
        isRequired
        label='description'
        error={errors['description']?.message}
        placeholder={formatMessage({ id: 'description' })}
        data-test='notification-description'
        rows={4}
      />
    </Card>
  );
};
